import React, { useEffect } from "react";
import Page from "../Page";
import ManageGroupWorkshop from "./ManageGroupWorkshop";
import { useDispatch } from "react-redux";
import { getActiveHeader } from "../../redux/home/actions";

const ManageWorkshopSection = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getActiveHeader("events-list"));
  }, []);
  return (
    <Page>
      <div className="container mt-5">
        <ManageGroupWorkshop />
      </div>
    </Page>
  );
};

export default ManageWorkshopSection;
